import script from "./Sentiment.vue?vue&type=script&setup=true&lang=js"
export * from "./Sentiment.vue?vue&type=script&setup=true&lang=js"

import "./Sentiment.vue?vue&type=style&index=0&id=b5918c4a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b5918c4a"]])

export default __exports__